<template>
  <div class="content-wrapper pt-3 height100">
    <div class="container-fluid ">
      <div class="card mb-2 height100">
        <div class="card-body" v-loading="loading">
          <!-- 内容开始 -->
          <el-button @click="$go_back" size="small">返回</el-button>
          <el-button class="ml-3" type="primary"
                     size="small" @click="query_roleAttr">
            新建角色
          </el-button>
          <div class="row mt-3" style="width:66%;margin:0 auto;">

            <div class="col-lg-6 ">
              <div class="card-header bg-info2 text-white">下级角色列表(拖动编辑关系)</div>
              <div class="card">
                <el-form class="form" @submit.native.prevent>
                  <div style="height: 550px;width:625px;overflow-y: scroll">
                    <adjustable_tree @back_call="choice_role" @del_call="del_role"

                                     :Data="{'obj':'role_tree','data':user_options,
                                                         'attr':{'id':'id','children':'children','label':'name',
                                                         'edit_func':'back_call','delete_func':'del_call',
                                                         'drop_func':'drop_call','drag':true,'delete':true,
                                                         'edit':true}}"></adjustable_tree>
                  </div>
                </el-form>
              </div>
              <el-button type="primary"
                         @click="save_role_tree">保存角色树结构
              </el-button>
              <!--              <el-button type="primary" @click="query_user_attr">新增用户（测试用-注册）</el-button>-->
            </div>
            <!-- 新建项目 end -->
            <!-- 配置内容start -->
            <div class="col-lg-6">
              <div class="card-header bg-info2 text-white">
                当前编辑角色：<span class="font14" style="color: #FFC107;"
                            >{{ current_role_name }}</span>
<!--                <div style="position: absolute;top: 10px;right: 15px">-->
<!--                  <el-button slot="trigger" size="small" @click="clear_role_choice" class="ml-2">重置-->
<!--                  </el-button>-->
<!--                </div>-->
              </div>
              <div class="card">
                <!-- 单个模块开始 -->
                <div class="pl-3 lh40 font16 text-info2"
                     style="border-bottom: 1px rgb(235 231 231) solid;color: #FF9800;">角色关联权限:
                </div>
                <div class="">
                  <div class=" p-3" v-if="check_flag">
                    <select_tree :Data="{'data':func_list,'attr':{'id':'code','children':'children','label':'chinese_name'
                                  ,'c_priority':'M','func':'func_data',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,
                                   'title':'角色关联功能',
                                   'checked_list':checked_func_list,'name':'角色关联功能','list':checked_func_list}}" @func_data="get_func_data"
                    ></select_tree>
                    <select_tree :Data="{'data':auth_list,'attr':{'id':'code','children':'children','label':'chinese_name'
                                  ,'c_priority':'M','func':'func_data',
                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,
                                   'title':'角色关联权限',
                                   'checked_list':checked_auth_list,'name':'角色关联权限','list':checked_auth_list}}" @func_data="get_auth_data"
                    ></select_tree>
                  </div>
                </div>
                <div class=" lh40 font16 pl-3 text-info2"
                     style="border-top: 1px rgb(235 231 231) solid;">角色关联用户:
                </div>
                <div class="">
                  <div class=" p-3">
                    <div v-if="check_flag">
                      <el-checkbox-group v-model="link_user" >
                        <el-checkbox :label="value.id" v-for="(value,index) in user_list" :key="index"
                        >{{ value.name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <el-button class="mt-3" type="primary"
                               @click="save_role_data(current_role.id)">保存修改内容
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 配置内容 end -->
          </div>
          <!-- 内容结束 -->
        </div>
      </div>
    </div>
    <!----------------------------主要内容结束------------------------->
    <!--        增加角色弹窗-->
    <el-dialog title="新增角色" :visible.sync="dialogVisible" v-if="dialogVisible" :show-close="false"
               :close-on-press-escape="false"
               :close-on-click-modal="false" width="30%" :destroy-on-close="true">
      <div >
        <div class="form-group row">
          <label class="col-sm-4 text-right lh35"> <i
              class="fa fa-asterisk text-danger font12 ml-1"
              aria-hidden="true"></i>角色名称：</label>
          <div class="col-sm-7">
            <el-input placeholder="请填写名称"
                      clearable v-model="role_name">
            </el-input>

          </div>
        </div>
        <div v-for="(item,index) in role_attr_list.object_data.static_attribute" :key="index">
          <equip_attr_temp  :Data="{'data':item,'attr':{'type':'role','objType':'role'}}"></equip_attr_temp>
        </div>
        <div class=" row mb-2">
          <label class="col-sm-4  text-lr lh40">
            <i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true"></i>角色类型：</label>
          <div class="col-sm-7 ">
            <el-select v-model='role_type' placeholder="请选择"
                       value-key="id" clearable>
              <el-option v-for="v in role_options" :key="v.id" :label="v.value" :value="v.value"
              ></el-option>
            </el-select>
          </div>

        </div>
<!--        <select_tree :Data="{'data':func_list,'attr':{'id':'code','children':'children','label':'chinese_name'-->
<!--                                  ,'c_priority':'M','func':'func_data',-->
<!--                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,-->
<!--                                   'title':'角色关联功能',-->
<!--                                   'checked_list':[],'name':'角色关联功能','list':null}}" @func_data="get_func_data"-->
<!--        ></select_tree>-->
<!--        <select_tree :Data="{'data':auth_list,'attr':{'id':'code','children':'children','label':'chinese_name'-->
<!--                                  ,'c_priority':'M','func':'func_data',-->
<!--                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,-->
<!--                                   'title':'角色关联权限',-->
<!--                                   'checked_list':[],'name':'角色关联权限','list':null}}" @func_data="get_auth_data"-->
<!--        ></select_tree>-->
<!--        <select_tree :Data="{'data':user_list,'attr':{'id':'id','children':'children','label':'name'-->
<!--                                  ,'c_priority':'M','func':'func_data',-->
<!--                                   'show_checkbox':true,'son_only':false,'half':true,'no_connect':true,'vuex_commit':true,-->
<!--                                   'title':'角色关联用户',-->
<!--                                   'checked_list':[],'name':'角色关联用户','list':null}}" @func_data="get_linkUser_data"-->
<!--        ></select_tree>-->

      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="add_role">保 存</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import select_tree from "@/components/IBMS/function/general_func_group/tree"
import adjustable_tree from "@/components/IBMS/function/special_func_group/adjustable_tree"
import equip_attr_temp from "@/components/IBMS/function/special_func_group/equip_attr_temp";

// import object_select from "@/components/IBMS/function/special_func_group/object_select";

export default {
  name: "edit_role",
  components: {select_tree, adjustable_tree,equip_attr_temp},
  data() {
    return {
      role_func_auth_button_flag: false,//角色关联功能权限按钮显示开关
      rol_user_button_flag: false,//角色关联用户按钮显示开关
      // user_project_button_flag: false,//用户关联项目按钮显示开关
      current_role: {'id': this.$store.state.role_id, 'name': this.$store.state.role_name},
      check_project_list: [],//选中用户关联项目列表
      project_list: [],//用户关联项目列表模板
      user_id: this.$store.state.user_id,//用户id
      project_id: this.$store.state.project_id,
      userVisible: false,//新增用户弹窗
      check_user_list: [],//选中用户列表
      activeName: '1',//当前展开用户项
      func_flag: false,//更新功能选择按钮用
      loading: false,//加载标志
      checked_func_list: [],//当前角色选中功能角色id列表
      role_id: this.$store.state.role_id,//角色id
      // role_name: this.$store.state.role_name,//角色名

      role_tree: [],//角色下级关系树结构
      user_list: [],//角色关联的用户列表
      new_user_attr_list: [],//新建用户属性列表列表
      save_role_tree_list: [],//修改后角色关系树
      save_role_tree_flag: false,//保存角色树按钮可见
      role_tree_flag: true,//角色树刷新用标记
      // user_project_flag: true,//用户关联项目刷新用标记
      user_options: [],
      dialogVisible: false,//新增角色弹窗
      role_attr_list:[],
      link_user:[],
      auth_list:[],
      func_list:[],
      checked_auth_list:[],
      c:[],
      role_name:'',
      current_role_name:'',
      check_flag:true,
      role_options: [
      //   {
      //   'id': '0',
      //   'value': '管理员'
      // }, {
      //   'id': '1',
      //   'value': '成员'
      // }, 
      {
        'id': '99',
        'value': '其他'
      }],
      role_type: '',

      // current_role_id:'',

    }
  },
  mounted() {
    console.log(this.$store.state.role_id,'fty')
    this.query_role_to_auth()//查权限
    this.query_role_to_func()//查功能
    // this.query_user_to_project(this.user_id, 1)
    // this.query_role_to_user()//查用户
    // this.query_role_tree()
    this.query_user()
  },
  methods: {
    //保存修改内容
    save_role_data(){
      this.$store.state.role_data.role_have_user=this.link_user

      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        data: {
          "version": "",
          "timestamp": "",
          "data": {
            "object_data":  this.$store.state.role_data
          }
        },
      }).then((response) => {
        console.log(response.data)
        if(response.data.result===200){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
        }
        this.query_user()

      })
    },
    //添加角色
    add_role(){
      console.log(this.$store.state.role_data.static_attribute,'ty8u')
      let check = this.$check_data([this.$store.state.role_data.static_attribute])
      if (!check) return
      this.$store.state.role_data.project=this.project_id
      this.$store.state.role_data.enabled_func[0].c_value = this.role_type

      this.$store.state.role_data.name=this.role_name
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        data: {
          "version": "",
          "timestamp": "",
          "data": {
            "object_data":  this.$store.state.role_data
          }
        },
      }).then((response) => {
        console.log(response.data)
        if(response.data.result===200){
          this.$message({
            message: '新建成功',
            type: 'success'
          });
          this.dialogVisible = false
          this.role_name=''
          this.query_user()

        }




      })
    },
    get_auth_data(data){
      this.$store.state.role_data.permission=data
    },
    get_func_data(data){
      this.$store.state.role_data.model=data
    },
    get_linkUser_data(data){
      this.$store.state.role_data.role_have_user=data
    },
    //查询权限
    query_role_to_func(){
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": "63",
          "role_id":1,
        },
      }).then((response) => {
        this.func_list=response.data.content.data
      })
    },
    //查询权限
    query_role_to_auth(){
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
            "object_code": "62",
            "role_id":1,
        },
      }).then((response) => {
        this.auth_list=response.data.content.data


      })
    },
    //chaxun角色表单相
    query_roleAttr() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "",
          "timestamp": "",
          "data": {
            "object_code": "4401"
          }
        },

      }).then((response) => {
        this.role_attr_list=response.data.content
        this.$store.commit('set_role_data',response.data.content.object_data)
        this.dialogVisible = true

      })
    },
    //查询用户
    query_user() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          project_id: this.project_id,
          object_code: '4401',
          // need_user_tree: '1',
        },

      }).then((response) => {
        this.user_options = response.data.content
      })
    },



    //拖动后回调
    // drop_role(value) {
    //   if (!this.save_role_tree_flag) this.save_role_tree_flag = true
    //   this.save_role_tree_list = value
    // },
    //保存角色树结构
    save_role_tree() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/EditObjectTree',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '4401',
            "project_id": this.project_id,
            "object_list": this.user_options,

          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!'
          });
          this.query_user()
        } else {
          this.$message({
            showClose: true,
            message: '保存失败请稍后重试',
            type: 'error'
          });
        }
        this.loading = false
      })
    },
    delete_role(value) {
      //删除角色
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "1.1",
          "data": {
            "id_list": [value.data.id],
            "flag": 'delete',
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            showClose: true,
            type: 'success',
            message: '删除成功!'
          });
          this.query_user()
        } else {
          this.$message({
            showClose: true,
            message: '删除失败请稍后重试',
            type: 'error'
          });
        }
      })
    },
    //删除角色
    del_role(value) {
      console.log(value)
      this.$confirm_delete('此操作将永久删除该角色及所有关联关系，并把该角色下级角色绑定至现角色下级, 是否继续?', 'delete_role', value)
    },
    //重置按钮
    // clear_role_choice() {
    //   this.current_role = {'id': this.$store.state.role_id, 'name': this.$store.state.role_name}
    //   this.checked_func_list = []
    //   this.activeName = null
    //   this.$store.commit('set_role_func_auth_data', [])
    //   this.func_flag = false
    //   this.check_user_list = []
    //   this.save_role_tree_list = []
    //   this.save_role_tree_flag = false
    //   this.user_project_button_flag = false
    //   this.rol_user_button_flag = false
    //   this.role_func_auth_button_flag = false
    //   this.query_role_tree()
    // },
    //选择角色-查详情
    choice_role(value) {
      this.check_flag=false
      this.current_role_name = value.data.name
      // this.query_role_to_auth(value.data.id)//查权限
      // this.query_role_to_func(value.data.id)//查功能
      this.query_role_to_user()
      // this.current_role_id = value.data.id
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "1.1",
          "data": {
            "id":  value.data.id
          }
        }
      }).then((response) => {
        console.log(response.data)
        if(JSON.stringify(response.data.content.object_data.model)==="{}"){
          this.checked_func_list=[]
        }else {
          this.checked_func_list=response.data.content.object_data.model

        }
        if(JSON.stringify(response.data.content.object_data.permission)==="{}"){
          this.checked_auth_list=[]
        }else {
          this.checked_auth_list=response.data.content.object_data.permission
        }
        this.link_user=response.data.content.object_data.role_have_user
        this.$store.commit('set_role_data',response.data.content.object_data)
        console.log(this.checked_func_list,'ss')
        this.check_flag=true
      })
    },

    //选中角色关联用户
    clickData(value, Data) {
      this.$get_objects(Data.obj, value)
      this.rol_user_button_flag = true
    },
    //查询角色下级关联所有用户(面板用户列表)
    query_role_to_user() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
            'object_code': '11',
          "project_id": this.project_id,
        }
      }).then((response) => {
        this.user_list = response.data.content[0].user_list
      })
    },
    //查询角色树形结构
    query_role_tree() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/global/CONFIG/EditRole/QueryRoleTree',
        data: {
          "version": "1.1",
          "data": {
            "project_id": this.project_id,
            "role_id": this.role_id,
          }
        }
      }).then((response) => {
        this.role_tree = response.data.content
        this.save_role_tree_list = response.data.content
        this.role_tree_flag = false
        this.$nextTick(() => {
          this.role_tree_flag = true
        })
      })
    },

  }
}
</script>

<style scoped>
/deep/ .el-tree-node__content {
  display: flex;
  align-items: center;
  height: 31px;
  cursor: pointer;
}
</style>
